import React from 'react';

interface PanelContainerProps {
  children: React.ReactNode;
  title?: string;
  onClose?: () => void;
  width?: string;
  height?: string;
}

export const PanelContainer: React.FC<PanelContainerProps> = ({ 
  children, 
  title, 
  onClose,
  width = 'auto',
  height = 'auto'
}) => {
  return (
    <div style={{
      background: 'rgba(20, 20, 25, 0.85)',
      border: '2px solid rgba(255, 215, 0, 0.3)',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
      width,
      height,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative'
    }}>
      {title && (
        <div style={{ 
          borderBottom: '1px solid rgba(255, 215, 0, 0.2)', 
          paddingBottom: '10px', 
          marginBottom: '15px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, color: '#ffd700', textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}>
            {title}
          </h3>
          {onClose && (
            <button 
              onClick={onClose}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: '1.2rem',
                cursor: 'pointer',
                padding: '0 5px'
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)'}
            >
              ×
            </button>
          )}
        </div>
      )}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {children}
      </div>
    </div>
  );
};
